export class GuessPriceInfo {
    constructor({
        currency = "PEN",
        housingValue = undefined,
        assetValue = undefined,
        startEnsureDate = null,
    } = {}) {
        this.currency = currency;
        this.housingValue = Number(housingValue);
        this.assetValue = Number(assetValue);
        this.startEnsureDate = startEnsureDate;
    }
}
